import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCubeContainer = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.9138 2.5854C12.332 2.32684 11.668 2.32684 11.0862 2.5854L3.28926 6.05071C2.65728 6.33158 2.25 6.9583 2.25 7.64988V16.3501C2.25 17.0417 2.65728 17.6684 3.28926 17.9493L10.8831 21.3244C11.5942 21.6404 12.4058 21.6404 13.1169 21.3244L20.7107 17.9493C21.3427 17.6684 21.75 17.0417 21.75 16.3501V7.64988C21.75 6.9583 21.3427 6.33158 20.7107 6.05071L12.9138 2.5854ZM11.6954 3.95612C11.8893 3.86993 12.1107 3.86993 12.3046 3.95612L19.1533 7L12 10.1793L4.84667 7L11.6954 3.95612ZM3.75 8.15407V16.3501C3.75 16.4489 3.80818 16.5385 3.89847 16.5786L11.25 19.8459V11.4874L3.75 8.15407ZM12.75 19.8459L20.1015 16.5786C20.1918 16.5385 20.25 16.4489 20.25 16.3501V8.15407L12.75 11.4874V19.8459Z",
		fill: "currentColor"
	})
});
export { SvgIconCubeContainer as ReactComponent };
